import { useSelector } from 'react-redux'
import Loading from './Loading'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { PrivateRoutes } from 'routes/rutas'

export default function LoadingSection() {
    const { user, roles } = useSelector((state) => state.auth)
    const navigate = useNavigate()

    useEffect(() => {
        if (user) {
            if (roles.includes('administrador')) {
                navigate(PrivateRoutes.HABILITARDOCENTE)
            } else if (roles.includes('uti')) {
                navigate(PrivateRoutes.REPORTES)
            } else if (roles.includes('docente')) {
                navigate(PrivateRoutes.HOMETEACHER)
            } else {
                navigate(PrivateRoutes.INICIO)
            }
        }
    }, [user])

	return <Loading />
}
